import React from "react";
import ReactEcharts from "echarts-for-react";
import "./index.scss";
import { UserProfileType } from "../../redux/auth/authTypes";
import { WorkFromHomeStatus } from "../../redux/stcoTools/stcoToolsType";
import BoxLoader from "../commons/BoxLoader/BoxLoader";
type AppProps = {
  history: any;
  userProfileAllData: UserProfileType;
  workFromHomeStatus: WorkFromHomeStatus;
  isApplyWFHApplyPresent: boolean;
  fetching: boolean;
};
const LoggedInUsersWFHBalance = ({
  history,
  userProfileAllData,
  workFromHomeStatus,
  isApplyWFHApplyPresent,
  fetching,
}: AppProps) => {
  const option = {
    tooltip: {
      trigger: "item",
      formatter: "{b}",
    },
    width: "500px",
    height: "350px",

    series: [
      {
        name: "Access From",
        type: "pie",
        radius: ["40%", ""],
        center: ["30%", "23%"],

        label: {
          show: false,
        },
        data: [
          {
            value: workFromHomeStatus?.approved_wfh,
            name: `Approved WFH ${workFromHomeStatus?.approved_wfh}`,
            itemStyle: { color: "#91cc75" },
          },
          {
            value: workFromHomeStatus?.pending_wfh,
            name: `Pending WFH ${workFromHomeStatus?.pending_wfh}`,
            itemStyle: { color: "#fac858" },
          },
          {
            value: workFromHomeStatus?.rejected_wfh,
            name: `Rejected ${workFromHomeStatus?.rejected_wfh}`,
            itemStyle: { color: "#ee6666" },
          },
          {
            value: workFromHomeStatus?.balance_wfh,
            name: `WFH Balance ${
              workFromHomeStatus?.balance_wfh -
                workFromHomeStatus?.approved_wfh -
                workFromHomeStatus?.pending_wfh <
              0
                ? 0
                : workFromHomeStatus?.balance_wfh -
                  workFromHomeStatus?.approved_wfh -
                  workFromHomeStatus?.pending_wfh
            }`,
            itemStyle: { color: "#5470c6" },
          },
        ],
      },
    ],
  };
  const handleApplyLeaveAndWhf = () => {
    history.push({
      pathname: `my-space/all-leaves-and-work-from-home`,
      state: { userProfileAllData, isModal: true, isType: "WFH" },
    });
  };

  const handleViewAllLeaves = () => {
    history.push({
      pathname: `my-space/all-leaves-and-work-from-home`,
      state: { userProfileAllData },
    });
  };
  return (
    <div className="boxs w-50 p-4" style={{ height: "300px" }}>
                  {fetching ? (
                    <BoxLoader style={{ height: "100%" }} />
                  ) : (
                    <>
      {!isApplyWFHApplyPresent && (
        <span className="boxs-container-heading">WFH Balance</span>
      )}
      {isApplyWFHApplyPresent ? (
        <>
          <div className="d-flex justify-content-between align-items-center w-100">
            <span className="boxs-container-heading">WFH Balance</span>

            {userProfileAllData?.hr_settings?.employment_status !==
            "Part time" ? (
              <span
                className="text-danger pointer"
                // disabled
                onClick={handleViewAllLeaves}
              >
                View All
              </span>
            ) : (
              ""
            )}
            <button
              className="btn btn-outline"
              disabled={
                userProfileAllData?.hr_settings?.employment_status ===
                "Part time"
              }
              onClick={handleApplyLeaveAndWhf}
            >
              Apply WFH
            </button>
          </div>
          <div
            style={{
              width: "100%",
              display: "flex",
              alignItems: "flex-start",
              justifyContent: "center",
              position: "relative",
              top: workFromHomeStatus?.balance_wfh !== 0 ? 0 : "36%",
            }}
          >
            {workFromHomeStatus?.balance_wfh !== 0 ? (
              <ReactEcharts option={option} style={{ width: 300 }} />
            ) : (
              ""
            )}
            <div
              style={{
                position: "absolute",
                color: "#6e7491",
                fontSize:
                  workFromHomeStatus?.balance_wfh !== 0 ? "14px" : "18px",
                fontWeight: 500,
                top: "53%",
                transform: "translateX(0%)",
                textAlign: "center",
              }}
            >
              WFH Balance
              <div
                style={{
                  color: "#262a44",
                  fontSize:
                    workFromHomeStatus?.balance_wfh !== 0 ? "20px" : "45px",
                  fontWeight: 500,
                }}
              >
                {workFromHomeStatus?.balance_wfh -
                  workFromHomeStatus?.approved_wfh -
                  workFromHomeStatus?.pending_wfh <
                0
                  ? 0
                  : workFromHomeStatus?.balance_wfh -
                    workFromHomeStatus?.approved_wfh -
                    workFromHomeStatus?.pending_wfh}
              </div>
            </div>
          </div>
        </>
      ) : (
        <div
          // className="mt-5"
          style={{
            color: "#6e7491",
            fontSize: "15px",
            fontWeight: 500,
            textAlign: "center",
            height: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          You don't have access to this feature
        </div>
      )}
      </>
                  )}
    </div>

  );
};

export default LoggedInUsersWFHBalance;
